import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { BaseClassModel, ClassColor } from '../../class/class.model';
import { ClassBackgroundComponent } from '../class-background/class-background.component';

@Component({
  selector: 'dojo-class-card',
  imports: [NgClass, IconComponent, ClassBackgroundComponent],
  templateUrl: './class-card.component.html',
  styleUrl: './class-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full' },
})
export class ClassCardComponent {
  readonly classData = input.required<BaseClassModel>();
  readonly showTeacherName = input(false);
  readonly isTeacherPreview = input(false);
  readonly clicked = output<BaseClassModel>();

  protected readonly isArchived = computed(() => !!this.classData().archived_at);

  protected readonly backgroundColor = computed<ClassColor>(() => {
    if (this.isArchived()) {
      return 'neutral';
    }

    return this.classData().color ?? 'indigo';
  });

  protected readonly badgeColorClass = computed(() => `bg-dynamic-${this.backgroundColor()}-100`);

  protected handleClick(): void {
    this.clicked.emit(this.classData());
  }
}
